import 'slick-carousel/slick/slick.min';

export default {
  init() {
    // JavaScript to be fired on the home page
    $('.people-slider').slick({
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
            variableWidth: true,
            centerMode: true,
          },
        },
      ],
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleAreaDiAttivita.js